/**
 * gengql documents for the invitation confirmation page (ENG-6310).
 *
 * The staff MCP prepares a batch of invitations and hands back a link to this
 * page; nothing is emailed until the staff member who prepared them presses
 * Send here. The api only lets that person read, send or cancel the batch.
 *
 * The three documents select the same fields so the page can render the batch
 * the mutations return (the state they actually reached) without a refetch.
 */
import { gengql } from '@/__generated__';

export const GET_CANDIDATE_INVITATION_BATCH = gengql(/* GraphQL */ `
  query getCandidateInvitationBatch($token: String!) {
    candidateInvitationBatch(token: $token) {
      id
      state
      expert_request_id
      expert_request_name
      expert_request_stage
      sender {
        name
        email
      }
      recipients {
        candidate_id
        profile_name
        emails
      }
      email {
        subject
        body
      }
      created_at
      expires_at
      sent_at
      cancelled_at
    }
  }
`);

export const SEND_CANDIDATE_INVITATION_BATCH = gengql(/* GraphQL */ `
  mutation sendCandidateInvitationBatch($token: String!) {
    sendCandidateInvitationBatch(token: $token) {
      id
      state
      expert_request_id
      expert_request_name
      expert_request_stage
      sender {
        name
        email
      }
      recipients {
        candidate_id
        profile_name
        emails
      }
      email {
        subject
        body
      }
      created_at
      expires_at
      sent_at
      cancelled_at
    }
  }
`);

export const CANCEL_CANDIDATE_INVITATION_BATCH = gengql(/* GraphQL */ `
  mutation cancelCandidateInvitationBatch($token: String!) {
    cancelCandidateInvitationBatch(token: $token) {
      id
      state
      expert_request_id
      expert_request_name
      expert_request_stage
      sender {
        name
        email
      }
      recipients {
        candidate_id
        profile_name
        emails
      }
      email {
        subject
        body
      }
      created_at
      expires_at
      sent_at
      cancelled_at
    }
  }
`);
